import authenticationProvider from '../../../../utilities/authentication/authenticationProvider';
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import config from '../../../../Config';

function InvoiceLoginTypeHandler(billUrl, typeOfInvoice, previous, loginType,InvoiceLoginTypeHandler) {

  if (loginType === 'full') {

    // CreateGaEvent(billUrl, typeOfInvoice, previous);
    // window.open(billUrl, '_blank');

  } else if (loginType === 'extendedOtp') {
    buildUrlAndOpenWindow(config.newLoginUrl)

  } else if (loginType === 'otp' || loginType.toUpperCase() == 'OTPSUBSCRIBER' || loginType.toUpperCase() == 'NEWOTP') {
    authenticationProvider.redirectToLogin(InvoiceLoginTypeHandler, location.pathname);
  }
}

function CreateGaEvent(billUrl, typeOfInvoice, previous) {
  if (previous) {
    gaEvent(
      gaParams.SELF_CARE_INVOICES_PREVIOUS_INVOICE_CLICK.category,
      gaParams.SELF_CARE_INVOICES_PREVIOUS_INVOICE_CLICK.eventType,
      gaParams.SELF_CARE_INVOICES_PREVIOUS_INVOICE_CLICK.eventParams
    );
  } else {
    gaEvent(
      gaParams.SELF_CARE_INVOICES_LAST_INVOICE_CLICK.category,
      gaParams.SELF_CARE_INVOICES_LAST_INVOICE_CLICK.eventType,
      gaParams.SELF_CARE_INVOICES_LAST_INVOICE_CLICK.eventType
    );
  }
}

function OpenOldInvoicesPage(invoicesPageUrl, loginType) {
  if (loginType === 'full') {
    buildUrlAndOpenWindow(invoicesPageUrl)
    // window.open(invoicesPageUrl, '_blank');
  }
  else if (loginType === 'extendedOtp') {
    buildUrlAndOpenWindow(config.newLoginUrl)
  }
  else if (loginType === 'otp' || loginType.toUpperCase() == 'OTPSUBSCRIBER' || loginType.toUpperCase() == 'NEWOTP') {
    authenticationProvider.redirectToLogin(invoicesPageUrl, location.pathname);
  }
}
export { InvoiceLoginTypeHandler, OpenOldInvoicesPage };
